import { render, staticRenderFns } from "./SubscriptionCard.vue?vue&type=template&id=20b744e2"
import script from "./SubscriptionCard.vue?vue&type=script&lang=js"
export * from "./SubscriptionCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports